import { Box, FormControlLabel, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import CustomSwitch from "../../../../../../components/CustomSwitch";

const JiraIncludeEntities = () => {
  const { values, setFieldValue } = useFormikContext();

  const includeEntitiesLabel = (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography variant="caption">
        Attach a CSV file of affected entities
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "fit-content",
      }}
    >
      <FormControlLabel
        control={
          <CustomSwitch
            checked={values.includeEntities}
            onChange={(event) =>
              setFieldValue("includeEntities", event.target.checked)
            }
          />
        }
        label={includeEntitiesLabel}
        labelPlacement="end"
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          mt: "16px",
          display: "flex",
          ml: "0",
          "& .MuiFormControlLabel-label": {
            marginLeft: "8px",
          },
        }}
      />
    </Box>
  );
};
export default JiraIncludeEntities;
